import _toConsumableArray from "@babel/runtime-corejs3/helpers/toConsumableArray";
import _slicedToArray from "@babel/runtime-corejs3/helpers/slicedToArray";
import _concatInstanceProperty from "@babel/runtime-corejs3/core-js-stable/instance/concat";
import React, { useMemo, useState, useContext, useEffect, createContext } from 'react';
import { createPortal } from 'react-dom';
import { TransitionSingle } from '@rexlabs/animation';
import { Backdrop } from './backdrop';
import { noop } from 'lodash';
export var OverlayContext = /*#__PURE__*/createContext({
  show: false,
  overlays: [],
  extendedConfigs: [],
  setShow: noop,
  setOverlays: noop,
  setExtendedConfigs: noop
});
var Provider = OverlayContext.Provider;
export function OverlayProvider(_ref) {
  var _ref2, _context;

  var children = _ref.children,
      _ref$configs = _ref.configs,
      configs = _ref$configs === void 0 ? ['fade'] : _ref$configs,
      _ref$scrollRoot = _ref.scrollRoot,
      scrollRoot = _ref$scrollRoot === void 0 ? window.document.body : _ref$scrollRoot;

  var _useState = useState(null),
      _useState2 = _slicedToArray(_useState, 2),
      show = _useState2[0],
      setShow = _useState2[1];

  var _useState3 = useState([]),
      _useState4 = _slicedToArray(_useState3, 2),
      overlays = _useState4[0],
      setOverlays = _useState4[1];

  var _useState5 = useState([]),
      _useState6 = _slicedToArray(_useState5, 2),
      extendedConfigs = _useState6[0],
      setExtendedConfigs = _useState6[1];

  var value = useMemo(function () {
    return {
      show: show,
      overlays: overlays,
      extendedConfigs: extendedConfigs,
      setShow: setShow,
      setOverlays: setOverlays,
      setExtendedConfigs: setExtendedConfigs
    };
  }, [show, overlays, extendedConfigs]); // Only give control of the backdrop to the outside when
  // there is only one overlay left
  // TODO: Is there any problems with this behaviour? The logic
  // is that since the `ActionMenu` doesn't know whether it's on
  // top of the `Dialog`, it's going to try and close the backdrop
  // when the action menu closes but we know here for sure that we
  // don't want that behaviour so we stop it at the source

  var showBackdrop = (_ref2 = overlays.length === 1 ? show : null) !== null && _ref2 !== void 0 ? _ref2 : overlays.length > 0;
  useEffect(function () {
    // Don't allow scrolling on the body
    // while the backdrop is visible
    if (showBackdrop) {
      scrollRoot.style.overflow = 'hidden';
      return function () {
        scrollRoot.style.overflow = '';
      };
    }
  }, [showBackdrop, scrollRoot]);
  return /*#__PURE__*/React.createElement(Provider, {
    value: value
  }, /*#__PURE__*/createPortal( /*#__PURE__*/React.createElement(TransitionSingle, {
    show: showBackdrop,
    configs: _concatInstanceProperty(_context = []).call(_context, _toConsumableArray(configs), _toConsumableArray(extendedConfigs))
  }, /*#__PURE__*/React.createElement(Backdrop, null)), document.body), children);
}
export function useOverlay() {
  return useContext(OverlayContext);
}